import { css, Interpolation, Theme } from '@emotion/react'

export const divider: Interpolation<Theme> = (theme) => css`
  width: 100%;
  border-bottom: 1px solid ${theme.backgrounds.backgroundOne};
`
